import {HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpStatusCode} from '@angular/common/http';
import {catchError, switchMap} from 'rxjs/operators';
import {AuthenticationService} from '~local/app/core/services/authentication.service';
import {RouterActionsService} from '~local/app/shared/services/router-actions.service';
import {inject} from '@angular/core';
import {throwError} from 'rxjs';

export const errorHandlerInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
    const authService = inject(AuthenticationService);
    const routerActionsService = inject(RouterActionsService);

    return next(req).pipe(
        catchError((errorResponse: Readonly<HttpErrorResponse>) => {
            if (errorResponse.error === 0 || errorResponse.status === HttpStatusCode.InternalServerError) {
                authService.forceLogout();
                return throwError(() => errorResponse);
            }

            if (errorResponse.status === HttpStatusCode.Unauthorized) {
                // TODO: Not sure if this should be that way!
                authService.doLogout$().pipe(
                    switchMap(() => routerActionsService.reload(true)),
                ).subscribe();
            }
            return throwError(() => errorResponse);
        }));
};
